import { useSearchPageSuggestedBrandInfo } from "@faire/retailer-visitor-shared/views/search-v2/__internal__/LazySearchPage/__internal__/SearchPage/DataFetching/Products/useSearchPageSuggestedBrandInfo";
import isEmpty from "lodash/isEmpty";

export const useSearchPageShouldShowBrandSearch = () => {
  const suggestedBrandInfo = useSearchPageSuggestedBrandInfo();
  return !!suggestedBrandInfo && !isEmpty(suggestedBrandInfo);
};
